<div *ngIf="data.icon" class="dialog-icon text-center">
  <ng-template [ngIf]="data.icon == 'success'">
    <mat-icon color="primary" class="icon-lg">check_circle</mat-icon>
  </ng-template>
  <ng-template [ngIf]="data.icon == 'error'">
    <mat-icon color="warn" class="icon-lg">error</mat-icon>
  </ng-template>
  <ng-template [ngIf]="data.icon == 'warning'">
    <mat-icon color="accent" class="icon-lg text-warning-msg">warning</mat-icon>
  </ng-template>
  <ng-template [ngIf]="data.icon == 'info'">
    <mat-icon color="primary" class="icon-lg">info</mat-icon>
  </ng-template>
</div>

<h1 mat-dialog-title class="text-center">{{data.title}}</h1>
<div mat-dialog-content class="text-center">
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions class="justify-content-center mb-0" *ngIf="data.buttons">
  <button mat-raised-button color="primary" class="btn-action" *ngFor="let btn of data.buttons" (click)="close(btn)">
    {{btn['value'] ? btn['value'] : btn}}
  </button>
</div>